// extracted by mini-css-extract-plugin
export var hackaway7logoClass = "v7-module--hackaway7logoClass--1mNfx";